module.exports = __webpack_public_path__ + "img/c03_unitwoadraider_Normal_ua.26d8180c.webp";